module.exports = "/_next/static/public/images/2f07836862b9703202f13b9812cbdc83-faaa7bad9c8d12abe38dd858f6972fd7.png";